export default {
  42: 'William Hill',
  532: 'Dafabet',
  285: '12bet / Dafabet / Mansion88 / IBCBet',
  340: 'Betway',
  30: 'Bwin / Partybets',
  635: 'Guts',
  44: 'Svenska Spel',
  118: 'Nordicbet',
  274: '10BET',
  234: '5 dimes / Island Casino',
  238: 'BETCRIS',
  221: 'skybet',
  291: 'Betfred / Tote',
  332: 'Betsafe',
  327: 'SBOBET',
  571: 'betISN',
  365: '188bet',
  567: 'Bovada',
  613: 'Betfair SB',
  539: 'Marathonbet',
  502: 'youwin / uwin',
  363: 'Tipico',
  342: 'Betsson Sportsbook',
  244: 'Coral',
  126: 'Bet 365',
  84: 'Paddy Power',
  43: 'Danske Spil',
  41: 'Norsk Tipping',
  17: 'Ladbrokes',
  6: 'Unibet / 888 / 32Red',
  22: 'BetVictor',
  5: 'Expekt',
  669: 'Pokerstars',
  34: 'Stan James',
  574: 'TonyBet',
  15: 'Intertops',
  212: 'sportsbook.com',
  378: 'bookmaker.eu',
  631: 'NetBet',
  689: 'Mobilbet'
}



/** WEBPACK FOOTER **
 ** ./src/config/bookmakers.js
 **/